import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

// Import the auto-populate script (using relative path)
import './auto_populate_assets.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);